import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {MenuItemComponent} from './menu-item/menu-item.component';
import {CommonModule} from '@angular/common';
import {UserService} from "../../../../../core/services/user.service";
import {Subscription} from "rxjs";
import {User} from "../../../../../graphql/generated";
import {MenuItem} from "primeng/api";


export interface MenuItemExtended extends MenuItem {
  permissionName: string;
}

@Component({
  selector: 'pegasus-menu',
  standalone: true,
  imports: [MenuItemComponent, CommonModule],
  templateUrl: './menu.component.html',
})
export class MenuComponent implements OnInit, OnDestroy {
  models: MenuItemExtended[] = [];
  user!: User;
  subscription!: Subscription;

  constructor(private userService: UserService) {
    this.subscription = this.userService.user$.subscribe((user) => {
      this.user = user;
      this.setModels();
    });
  }


  ngOnInit() {
    this.setModels();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private getModels(): MenuItemExtended[] {
    return [
      {
        label: 'Catalogue',
        permissionName: 'catalogue',
        icon: 'pi pi-fw pi-briefcase',
        items: [
          {
            label: 'Products',
            routerLink: ['/main/products'],
          },
          {
            label: 'Categories',
            routerLink: ['/main/categories'],
          },
          {
            label: 'Sub Categories',
            routerLink: ['/main/sub-categories'],
          },
          {
            label: 'Category Sch..',
            routerLink: ['/main/cat-schedules'],
          },
          {
            label: 'Customization',
            routerLink: ['/main/customization-groups'],
          },
          {
            label: 'Taxes',
            routerLink: ['/main/taxes'],
          },
          {
            label: 'Charges',
            routerLink: ['/main/charge'],
          },
          {
            label: 'Menu Sync',
            routerLink: ['/main/aggregator'],
          },
          {
            label: 'Menus',
            routerLink: ['/main/menus'],
          },

        ],
      },
      {
        label: 'Web Ordering',
        permissionName: 'website',
        icon: 'pi pi-fw pi-briefcase',
        items: [
          {
            label: 'Website',
            routerLink: ['/main/website'],
          },
        ],
      },
      {
        label: 'Discounts',
        permissionName: 'discount',
        icon: 'pi pi-fw pi-briefcase',
        items: [
          {
            label: 'Discounts',
            routerLink: ['/main/discount'],
          },
          {
            label: 'Coupons',
            routerLink: ['/main/coupon']
          },
          {
            label: 'Employees',
            routerLink: ['/main/employees']
          }
        ],
      },
      {
        label: 'User',
        permissionName: 'user',
        icon: 'pi pi-fw pi-briefcase',
        items: [

          {
            label: 'Users',
            routerLink: ['/main/user'],
          },
          {
            label: 'Roles',
            routerLink: ['/main/role'],
          },
        ],
      },
      {
        label: 'Settings',
        permissionName: 'settings',
        icon: 'pi pi-fw pi-briefcase',
        items: [
          {
            label: 'Printers',
            routerLink: ['/main/printer-config'],
          },
          {
            label: 'Sections',
            routerLink: ['/main/section'],
          },
          {
            label: 'Instances',
            routerLink: ['/main/instance'],
          },
          {
            label: 'Branches',
            routerLink: ['/main/branch'],
          },
          {
            label: 'Payment Mode',
            routerLink: ['/main/payment-mode'],
          },
          {
            label: 'Settings',
            routerLink: ['/main/settings'],
          }
        ],
      },
      {
        label: 'Integration',
        permissionName: 'integration',
        icon: 'pi pi-fw pi-briefcase',
        items: [
          {
            label: 'Integration',
            routerLink: ['/main/integration'],
          }
        ],
      },
      {
        label: 'Reports',
        permissionName: 'reports',
        icon: 'pi pi-fw pi-briefcase',
        items: [
          {
            label: 'Reports',
            routerLink: ['/main/reports'],
          },
        ],
      },
    ];
  }

  private setModels() {
    const models = [];
    const allModels = this.getModels();
    const rolePermissions = this.user?.role?.role_permissions;

    for (const model of allModels) {
      const permissionName = model.permissionName;
      const permission = rolePermissions?.find((p: any) => p.permission.name === permissionName);

      if (permission) {
        models.push(model);
      }
    }
    this.models = models;
  }
}
